import { useCallback, useMemo } from 'preact/hooks';
import { TCFPurpose } from '@usercentrics/cmp-browser-sdk';
import { TCFState } from '../../contexts/TcfContext';
import { sortById } from '../../modules/sort';

export type PurposeProps = {
  checked: boolean;
  legitimateInterestChecked: boolean;
  purpose: TCFPurpose;
  onPurposeConsentToggle: () => void;
  onPurposeLegitimateInterestToggle: () => void;
};

const MapPurposes: (props: TCFState) => PurposeProps[] = ({ setTcfData, tcfData }) => {
  const onPurposeToggleHandler = useCallback(
    (newConsentChecked: boolean, newLegitimateInterestChecked: boolean, id: number): void => {
      if (!tcfData?.purposes) {
        return;
      }
      setTcfData({
        ...tcfData,
        purposes: tcfData.purposes.map((purpose) =>
          purpose.id === id
            ? {
                ...purpose,
                consent: newConsentChecked,
                legitimateInterestConsent: newLegitimateInterestChecked,
              }
            : purpose,
        ),
      });
    },
    [setTcfData, tcfData],
  );

  const sortedPurposes = useMemo(() => {
    if (tcfData) {
      return sortById(tcfData.purposes);
    }

    return [];
  }, [tcfData]);

  return sortedPurposes.map((purpose) => {
    const checked = purpose.consent || false;
    const legitimateInterestChecked =
      purpose.legitimateInterestConsent != null ? purpose.legitimateInterestConsent : true;

    const onPurposeConsentToggle = (): void => {
      onPurposeToggleHandler(!checked, legitimateInterestChecked, purpose.id);
    };

    const onPurposeLegitimateInterestToggle = (): void => {
      onPurposeToggleHandler(checked, !legitimateInterestChecked, purpose.id);
    };

    return {
      checked,
      legitimateInterestChecked,
      onPurposeConsentToggle,
      onPurposeLegitimateInterestToggle,
      purpose,
    };
  });
};

export default MapPurposes;
